import moment from 'moment'

const prepareShow = feed => {
  return feed
}

export default {
  doLoad () {
    this.$http.get('/v1/dweller/posts')
      .then(({data}) => {
        this.feeds = prepareShow({...data})
      })
  },
  realTime (dt) {
    moment.updateLocale('pt-br', {
      relativeTime: {
        past: function (dt) { return dt === 'agora mesmo' ? dt : dt + '' },
        s: 'agora mesmo',
        future: 'á %s',
        ss: '%d segundos',
        m: 'um minuto',
        mm: '%d minutos atrás',
        h: 'uma hora atrás',
        hh: '%d horas atrás',
        d: 'um dia',
        dd: '%d dias atrás',
        M: 'um mês',
        MM: '%d meses atrás',
        y: 'um ano',
        yy: '%d anos atrás'
      }
    })

    const d = parseInt(dt)
    return moment(d).fromNow()
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/overview/components/feed/resources/methods.js